<template>
  <v-data-table-server class="mt-2" :headers="headers" :items="items" :loading="loading"
    v-model:items-per-page="itemsPerPage" @update:options="getOrders" :items-length="totalItems" :search="search"
    :page="page" :sort-by="sortBy">
    <template v-slot:top v-if="departments.length || studies.length">
      <v-row>
        <v-col>
          <v-select clearable v-if="departments.length" label="Комплекс" :items="departments" item-title="name"
            item-value="id" v-model="filters.department"></v-select>
        </v-col>
        <v-col>
          <v-select clearable v-if="studies.length" label="Форма обучения" :items="studies" item-title="name"
            item-value="id" v-model="filters.study"></v-select>
        </v-col>
        <v-col cols="2" v-if="$model.isAdmin">
          <log target="documents" objecttable="psm_documents">
          </log>
        </v-col>
      </v-row>
      <v-btn max-width="250" color="primary"
        :disabled="departments.length != 0 && !filters.department || studies.length != 0 && !filters.study"
        @click="createOrder">
        Создать приказ
      </v-btn>
    </template>

    <template v-slot:item="{ item }">
      <tr>
        <td>
          <router-link :to="{ path: '../document/' + item.id }">
            <v-icon color="primary" size="x-large">mdi-text-box-edit</v-icon>
          </router-link>
          <a class="d-block cursor-pointer hover-transparent mt-2" @click="printDocument(item.id)">
            <v-icon color="primary" size="x-large">mdi-printer</v-icon>
            <!--<v-tooltip activator="parent" location="end">Распечатать</v-tooltip>-->
          </a>
          <template v-if="item.candelete">
            <a class="d-block cursor-pointer hover-transparent" @click="deleteDocument(item)">
              <v-icon style="margin: 0 !important;" color="error" size="x-large">mdi-trash-can</v-icon>
              <!--<v-tooltip activator="parent" location="end">Удалить</v-tooltip>-->
            </a>
          </template>
        </td>
        <td><a :href="$model.wwwroot + '/user/profile.php?id=' + item.author_id">{{ item.author }}</a></td>
        <td>
          <a class="d-block" v-if="item.next_user_id"
            :href="$model.wwwroot + '/user/profile.php?id=' + item.next_user_id">{{
              item.status
            }}</a>
          <span class="d-block" v-else>{{ item.status }}</span>
          <span :style="{ color: state[item.state].color }">{{ state[item.state].name }}</span>
        </td>
        <td>{{ item.ordernum }}</td>
        <td>{{ item.orderdate }}</td>
        <td>
          <template v-for="student in item.students.slice(0, item.studentItems)">
            <a target="_blank" :href="$model.wwwroot +
              '/blocks/manage_groups/personal/personal-card.php?user_id=' +
              student.id
              ">
              {{ student.name }}&nbsp;
            </a>
          </template>
          <a class="text-blue-lighten-2 cursor-pointer"
            v-if="item.students.length > item.studentItems && item.studentItems < 1000"
            @click="item.studentItems = 1000">(показать больше)</a>
          <a class="text-blue-lighten-2 cursor-pointer" v-if="item.studentItems == 1000"
            @click="item.studentItems = 5">(Скрыть)</a>
        </td>
        <td>{{ item.dep }}</td>
        <td>{{ item.study }}</td>
      </tr>
    </template>
  </v-data-table-server>
  <confirmdlg ref="confirm" />
</template>

<script>
import confirmDialog from 'moodleDir/procollege/lib/vue/confirm-dialog.vue';
import log from "moodleDir/procollege/lib/vue/log.vue";
import docStore from "./store.js"
export default {
  components: {
    confirmdlg: confirmDialog,
    log
  },
  data() {
    return {
      state: [
        {
          name: "отменен",
          color: "red",
        },
        {
          name: "сохранен",
          color: "black",
        },
        {
          name: "отправлен на подписание",
          color: "blue",
        },
        {
          name: "утвержден",
          color: "green",
        },
        {
          name: "отправлен на согласование",
          color: "blue",
        },
        {
          name: "согласован",
          color: "green",
        },
        {
          name: "отклонен",
          color: "red",
        },
        {
          name: "отложен",
          color: "red",
        },
        {
          name: "отправлен на исполнение",
          color: "blue",
        },
        {
          name: "отправлен на доработку",
          color: "red",
        },
        {
          name: "отказано",
          color: "red",
        },
      ],
      search: null,
      headers: [],
      items: [],
      departments: [],
      studies: [],
      filters: {
        department: null,
        study: null,
      },
      loading: false,
      itemsPerPage: 10,
      totalItems: 0,
      page: 1,
      sortBy: [],
      abortControl: [],
    };
  },
  watch: {
    computedFilters: {
      handler(val, oldVal) {
        if (val.department == null && val.study == null) {
          return;
        }
        this.search = JSON.stringify(this.filters);
      },
      deep: true,
    },
  },
  computed: {
    computedFilters() {
      return Object.assign({}, this.filters)
    }
  },
  created() {
    if (!this.$store.hasModule('documentStore')) {
      this.$store.registerModule('documentStore', docStore);
    }

    let orderlist = this.$model.store?.DocumentsStore?.orderList[this.$route.params.id];
    if (orderlist) {
      let filters = orderlist.filter;

      this.filters.department = filters.department ? '' + filters.department : null;
      this.filters.study = filters.study ? '' + filters.study : null;
      this.itemsPerPage = '' + filters.itemsPerPage;
      //-------------------------------------------
      let sort = orderlist.sortBy;
      this.sortBy = [{ key: sort.field, order: sort.order }];
    }

    this.axios
      .post(
        this.$model.wwwroot +
        "/procollege/manage_groups/documents3/ordersListGetCrumbs",
        new URLSearchParams({
          categoryid: this.$route.params.id,
        })
      )
      .then((response) => {
        this.$eventBus.$emit("set-crumbs", response.data);
      })
      .catch((error) => {
        this.axiosDefaultErrorHandler(error);
      });

    this.axios
      .post(
        this.$model.wwwroot +
        "/procollege/manage_groups/documents3/ordersListGetFilters",
        new URLSearchParams({
          categoryid: this.$route.params.id,
        })
      )
      .then((response) => {
        if (response.data.departments) {
          //если значение только 1 нет смысла показывать список на выбор
          if (response.data.departments.length == 1) {
            this.filters.department = Object.values(
              response.data.departments
            )[0].id;
          } else {
            for (let k in response.data.departments) {
              this.departments.push(response.data.departments[k]);
            }
          }
        }

        if (response.data.studies) {
          //если значение только 1 нет смысла показывать список на выбор
          if (response.data.studies.length == 1) {
            this.filters.study = Object.values(response.data.studies)[0].id;
          } else {
            for (let k in response.data.studies) {
              this.studies.push(response.data.studies[k]);
            }
          }
        }
      })
      .catch((error) => {
        this.axiosDefaultErrorHandler(error);
      });
    //this.getOrders();
  },
  methods: {
    createOrder() {
      //vuex стор используется только для текущего состояния, перехода со страницы на страницу для удобной передачи параметров
      //то что нужно хранить более-менее долго в php store
      //мудл при каждом обновлении чистит local storage для домена целиком
      this.$store.commit("documentStore/SET_STATE", {
        categoryid: this.$route.params.id,
        departmentid: this.filters.department,
        studyid: this.filters.study
      });

      this.$router.push({
        path: "../document/0",
      });
    },
    printDocument(orderid) {
      let params = {
        orderid: orderid
      }
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/manage_groups/documents3/printDocument",
          new URLSearchParams(params),
          {
            responseType: 'blob'
          }
        )
        .then((response) => {
          let link = document.createElement("a");
          link.href = URL.createObjectURL(response.data);

          let filename = "document.docx"
          if (typeof response.headers["content-disposition"] != "undefined") {
            t = response.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
            if (t[1] != "undefined") {
              filename = decodeURIComponent(t[1]);
              filename = filename.replace(/[\"\'\\]/g, '')
            }
          }

          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          this.axiosDefaultErrorHandler(error);
        });
    },
    getOrders({ page, itemsPerPage, sortBy }) {
      //уже отправленные и еще не обработанные запросы не интересны
      let abortControl_;
      while ((abortControl_ = this.abortControl.pop())) {
        abortControl_.abort();
      }
      //------------------------------------------
      abortControl_ = new AbortController();
      this.abortControl.push(abortControl_);

      this.loading = true;
      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/manage_groups/documents3/ordersListGetOrders",
          new URLSearchParams({
            categoryid: this.$route.params.id,
            perPage: itemsPerPage,
            page: page,
            study: this.filters.study,
            department: this.filters.department,
            sortBy: JSON.stringify(sortBy),
          }),
          {
            signal: abortControl_.signal,
          }
        )
        .then((response) => {
          this.abortControl = this.abortControl.filter(el => abortControl_ !== el)
          this.headers = response.data.data.columns;
          this.items = response.data.data.rows;
          this.totalItems = response.data.totalItems;
          this.loading = false;
        })
        .catch((error) => {
          this.abortControl = this.abortControl.filter(el => abortControl_ !== el)
          this.loading = false;
          this.axiosDefaultErrorHandler(error);
        });
    },
    async deleteDocument(item) {
      if (
        await this.$refs.confirm.open(
          "Подтверждение",
          "Вы действительно хотите удалить документ №" + item.ordernum + " от " + item.orderdate + " ?"
        )
      ) {
        this.axios
          .post(
            this.$model.wwwroot +
            "/procollege/manage_groups/documents3/delete",
            new URLSearchParams({
              orderid: item.id,
            })
          )
          .then((response) => {
            let tmp = []
            this.items.forEach((element, index) => {
              if (element.id != item.id) {
                tmp.push(element)
              }
            });
            this.items = tmp;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
};
</script>
<style lang="css" scoped>
.hover-transparent:hover {
  opacity: 50%;
}
</style>